/* eslint-disable */
import { useState, useEffect, useRef, Fragment } from 'react';
import { gudangAPI, proyekAPI, masterAPI, pengadaanAPI, uploadAPI } from '../services/api';
import { useGR } from '../services/usePengadaan';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';

function formatRp(n) { return 'Rp ' + Number(n||0).toLocaleString('id-ID'); }
function tglHariIni() { return new Date().toISOString().split('T')[0]; }
function generateId(prefix, list) {
  const tahun = new Date().getFullYear();
  const urut  = String(list.length + 1).padStart(3, '0');
  return `${prefix}-${tahun}-${urut}`;
}

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Modal({ show, onClose, title, children, footer, size='620px' }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div className="modal-box-erp" style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:size, maxHeight:'100vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>{children}</div>
        {footer && <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>{footer}</div>}
      </div>
    </div>
  );
}

function KopFormulir({ judulFormulir, rows }) {
  const totalRows = rows.length;

  return (
    <div className="kop-formulir-erp" style={{
      display:'grid',
      gridTemplateColumns:'80px 1.6fr 90px 1fr',
      gridTemplateRows: `repeat(${totalRows}, auto)`,
      border:'1.5px solid #000',
      fontFamily:'inherit', color:'#000', background:'white'
    }}>
      <div style={{
        gridColumn:'1', gridRow:`1 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', alignItems:'center', justifyContent:'center', padding:'4px'
      }}>
        <img src={`${process.env.PUBLIC_URL}/kop mkmj.jpg`} alt="Logo PT Mitra Karya Mandiri Jaya"
          style={{ width:'100%', height:'100%', objectFit:'contain' }} />
      </div>

      <div style={{
        gridColumn:'2', gridRow:'1',
        borderRight:'1.5px solid #000', borderBottom:'1.5px solid #000',
        padding:'6px 12px', textAlign:'center',
        display:'flex', alignItems:'center', justifyContent:'center'
      }}>
        <span style={{ fontWeight:'700', fontSize:'13px' }}>PT. MITRA KARYA MANDIRI JAYA</span>
      </div>

      <div style={{
        gridColumn:'2', gridRow:`2 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'2px',
        padding:'6px 12px', textAlign:'center'
      }}>
        <div style={{ fontWeight:'700', fontSize:'13px' }}>FORMULIR</div>
        <div style={{ fontWeight:'700', fontSize:'13px', textTransform:'uppercase' }}>{judulFormulir}</div>
      </div>

      {rows.map(([label, value], i) => (
        <Fragment key={label || i}>
          <div key={`l-${label}`} style={{
            gridColumn:'3', gridRow: i+1,
            borderRight:'1px solid #000',
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            {label}
          </div>
          <div key={`v-${label}`} style={{
            gridColumn:'4', gridRow: i+1,
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            : {value}
          </div>
        </Fragment>
      ))}
    </div>
  );
}


function Btn({ onClick, color='biru', children, disabled, size='normal' }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white' },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white' },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white' },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd' },
  };
  const c = colors[color];
  const pad = size==='small' ? '5px 12px' : '9px 16px';
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:pad, background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize: size==='small'?'12px':'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function Badge({ status }) {
  const map = {
    'Baik':             { label:'✅ Baik',          bg:'#eafaf1', color:'#27ae60' },
    'Ada yang rusak':   { label:'⚠️ Rusak',         bg:'#fef5e7', color:'#e67e22' },
    'Rusak sebagian':   { label:'⚠️ Rusak sebagian', bg:'#fef5e7', color:'#e67e22' },
    'Tidak sesuai spesifikasi': { label:'❌ Tdk sesuai spek', bg:'#fdedec', color:'#e74c3c' },
    'Kurang quantity':  { label:'📉 Kurang qty',    bg:'#fdedec', color:'#e74c3c' },
  };
  const s = map[status] || { label: status, bg: '#f0f4f8', color: '#666' };
  return (
    <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:s.bg, color:s.color, whiteSpace:'nowrap' }}>
      {s.label}
    </span>
  );
}


function FG({ label, required, children, span }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: span?'1/-1':'auto' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>{label} {required && <span style={{ color:'#e74c3c' }}>*</span>}</label>
      {children}
    </div>
  );
}

const proyekListStatic = [
  { id:1, kode:'', nama:'Gedung Kantor Surabaya' },
  { id:2, kode:'', nama:'Renovasi RSUD Sidoarjo' },
  { id:3, kode:'', nama:'Jalan Lingkar Gresik'   },
  { id:4, kode:'', nama:'Tower Apartemen Malang'  },
];

function useProyekListG() {
  const [list, setList] = useState(proyekListStatic);
  useEffect(() => {
    proyekAPI.getAll().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(p => ({ id: p.id, kode: p.kode||'', nama: p.nama }))
          .sort((a,b) => a.nama.localeCompare(b.nama,'id'));
        setList(sorted);
      }
    }).catch(()=>{});
  }, []);
  return list;
}

function useVendorListG() {
  const [list, setList] = useState([]);
  useEffect(() => {
    masterAPI.getAllVendor().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(v => ({ id:v.id, kode:v.kode||'', nama:v.nama }))
          .sort((a,b) => a.nama.localeCompare(b.nama,'id'));
        setList(sorted);
      }
    }).catch(()=>{});
  }, []);
  return list;
}

function SelectSupplierG({ value, onChange, list, placeholder = '-- Pilih Supplier --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const filtered = list.filter(v =>
    !search ||
    v.nama.toLowerCase().includes(search.toLowerCase()) ||
    (v.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ color: value?'#333':'#aaa', fontSize:'13px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {value || placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'240px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama supplier..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(v => (
              <div key={v.id}
                onClick={() => { onChange(v.nama); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: v.nama===value?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = v.nama===value ? '#eaf0fb' : 'white'}
              >
                <strong>{v.nama}</strong>{v.kode && <span style={{ color:'#888' }}> · {v.kode}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function SelectMaterialG({ value, onChange, list, onPilihItem, placeholder = '-- Manual --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const selected = list.find(m => String(m.id) === String(value));
  const filtered = list.filter(m =>
    !search ||
    m.nama.toLowerCase().includes(search.toLowerCase()) ||
    (m.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 8px', fontSize:'12px' }}>
        <span style={{ color: selected?'#333':'#aaa', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {selected ? selected.nama : placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'240px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama material..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            <div
              onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
              style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', color:'#aaa' }}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}
            >
              -- Manual --
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(m => (
              <div key={m.id}
                onClick={() => { onChange(String(m.id)); if(onPilihItem) onPilihItem(m); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: String(m.id)===String(value)?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = String(m.id)===String(value) ? '#eaf0fb' : 'white'}
              >
                <strong>{m.nama}</strong>{m.satuan && <span style={{ color:'#888' }}> · {m.satuan}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function SelectProyek({ value, onChange, list, placeholder = '-- Pilih Proyek --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const wrapRef = useRef(null);

  const selected = list.find(p => String(p.id) === String(value));
  const filtered = list.filter(p =>
    !search ||
    p.nama.toLowerCase().includes(search.toLowerCase()) ||
    (p.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) { setOpen(false); setSearch(''); }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapRef} style={{ position:'relative' }}>
      <div onClick={() => setOpen(!open)} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ color: selected?'#333':'#aaa', fontSize:'13px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {selected ? (selected.kode ? `${selected.kode} · ${selected.nama}` : selected.nama) : placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div style={{
          position:'absolute', top:'100%', left:0, right:0, marginTop:'4px',
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.15)', zIndex:1000,
          maxHeight:'280px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik kode atau nama proyek..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            <div onClick={() => { onChange(''); setOpen(false); setSearch(''); }} style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', color:'#aaa' }}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'} onMouseLeave={e=>e.currentTarget.style.background='white'}>
              -- Kosongkan --
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(p => (
              <div key={p.id} onClick={() => { onChange(String(p.id)); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: String(p.id)===String(value) ? '#eaf0fb' : 'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = String(p.id)===String(value) ? '#eaf0fb' : 'white'}>
                {p.kode && <strong>{p.kode}</strong>}{p.kode && ' · '}{p.nama}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function SelectMaterial({ value, onChange, list, onPilihItem, placeholder = '-- Pilih Material --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const filtered = list.filter(m =>
    !search ||
    m.nama.toLowerCase().includes(search.toLowerCase()) ||
    (m.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
     <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'flex-start', padding:'5px 8px', fontSize:'12px', minHeight:'34px' }}>
        <span style={{ color: value?'#333':'#aaa', whiteSpace:'normal', wordBreak:'break-word', lineHeight:'1.3' }}>{value || placeholder}</span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px', flexShrink:0, marginTop:'3px' }}>▼</span>
      </div>
      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000, maxHeight:'260px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama atau kode material..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(m => (
              <div key={m.id} onClick={() => { onChange(m.nama); if(onPilihItem) onPilihItem(m); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: m.nama===value?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = m.nama===value?'#eaf0fb':'white'}>
                <strong>{m.nama}</strong>{m.satuan && <span style={{ color:'#888' }}> · {m.satuan}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function SelectSupplier({ value, onChange, list, placeholder = '-- Pilih Supplier --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const filtered = list.filter(v =>
    !search ||
    v.nama.toLowerCase().includes(search.toLowerCase()) ||
    (v.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center', padding:'5px 8px', fontSize:'12px' }}>
        <span style={{ color: value?'#333':'#aaa', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{value || placeholder}</span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>
      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000, maxHeight:'240px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik nama atau kode supplier..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(v => (
              <div key={v.id} onClick={() => { onChange(v.nama); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: v.nama===value?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = v.nama===value?'#eaf0fb':'white'}>
                <strong>{v.nama}</strong>{v.kode && <span style={{ color:'#888' }}> · {v.kode}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}


// ============================================
// TAB: STOK MATERIAL
// ============================================
function TabStok({ gudangList }) {
  const [stok, setStok]           = useState([]);
  const [loading, setLoading]     = useState(true);
  const [filterGudang, setFilterGudang] = useState('');
  const [search, setSearch]       = useState('');

  useEffect(() => { fetchData(); }, [filterGudang]);

  async function fetchData() {
    setLoading(true);
    try {
      const result = await gudangAPI.getStok(filterGudang?{gudang_id:filterGudang}:{});
      if (result.ok) setStok(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  const filtered = stok.filter(s =>
    !search || s.nama_barang.toLowerCase().includes(search.toLowerCase()) || s.kode_barang.toLowerCase().includes(search.toLowerCase())
  );

  const totalJenis = new Set(filtered.map(s=>s.barang_id)).size;
  const totalMenipis = filtered.filter(s => Number(s.qty) <= Number(s.stok_minimum) && Number(s.stok_minimum) > 0).length;

  if (loading) return <LoadingSpinner pesan="Memuat data stok..." />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px' }}>
        <div style={{ background:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', borderRadius:'12px', padding:'20px', color:'white' }}>
          <div style={{ fontSize:'20px' }}>📦</div>
          <div style={{ fontSize:'22px', fontWeight:'700' }}>{totalJenis}</div>
          <div style={{ fontSize:'12px', opacity:0.85 }}>Jenis Barang Tersedia</div>
        </div>
        <div style={{ background:'linear-gradient(135deg,#1e8449,#27ae60)', borderRadius:'12px', padding:'20px', color:'white' }}>
          <div style={{ fontSize:'20px' }}>🏬</div>
          <div style={{ fontSize:'22px', fontWeight:'700' }}>{gudangList.length}</div>
          <div style={{ fontSize:'12px', opacity:0.85 }}>Lokasi Gudang</div>
        </div>
        <div style={{ background: totalMenipis>0?'linear-gradient(135deg,#c0392b,#e74c3c)':'linear-gradient(135deg,#616a6b,#839192)', borderRadius:'12px', padding:'20px', color:'white' }}>
          <div style={{ fontSize:'20px' }}>⚠️</div>
          <div style={{ fontSize:'22px', fontWeight:'700' }}>{totalMenipis}</div>
          <div style={{ fontSize:'12px', opacity:0.85 }}>Stok Menipis</div>
        </div>
      </div>

      <div style={{ display:'flex', gap:'10px' }}>
        <select value={filterGudang} onChange={e=>setFilterGudang(e.target.value)} style={{ ...inputStyle, maxWidth:'220px' }}>
          <option value="">Semua Gudang</option>
          {gudangList.map(g=><option key={g.id} value={g.id}>{g.nama}</option>)}
        </select>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari nama/kode barang..." style={{ ...inputStyle, maxWidth:'260px' }} />
      </div>

      {filtered.length === 0 ? (
        <EmptyState icon="📦" judul="Stok kosong" sub="Belum ada stok barang di gudang ini" />
      ) : (
        <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
              {['Kode','Nama Barang','Kategori','Gudang','Stok','Satuan','Min. Stok','Status'].map(h=>(
                <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {filtered.map(s=>{
                const menipis = Number(s.stok_minimum) > 0 && Number(s.qty) <= Number(s.stok_minimum);
                return (
                  <tr key={s.id} style={{ borderBottom:'1px solid #f5f7fa', background: menipis?'#fff8f8':'white' }}>
                    <td style={{ padding:'12px', fontSize:'12px', fontWeight:'700' }}>{s.kode_barang}</td>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'500' }}>{s.nama_barang}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{s.kategori||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{s.nama_gudang}</td>
                    <td style={{ padding:'12px', fontSize:'14px', fontWeight:'700', color: menipis?'#e74c3c':'#1a3a5c' }}>{Number(s.qty).toLocaleString('id-ID')}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{s.satuan}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#888' }}>{s.stok_minimum}</td>
                    <td style={{ padding:'12px' }}>
                      {menipis
                        ? <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:'#fdedec', color:'#e74c3c' }}>⚠️ Menipis</span>
                        : <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:'#eafaf1', color:'#27ae60' }}>✅ Aman</span>
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ============================================
// TAB: PENERIMAAN BARANG (BAPB)
// ============================================
function TabGR({ user, barangList }) {
  const dataProyekList = useProyekListG();
  const dataVendorListLive = useVendorListG();
  const { data: listGR, loading, error, refetch } = useGR();
  const [showForm, setShowForm]     = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const itemKosong = { nama:'', spesifikasi:'', satuan:'', jumlahPO:'', jumlahTerima:'', kondisi:'', sesuai:'' };
  const [form, setForm] = useState({
    proyek_id:'', po_id:'', no_proyek:'', nama_proyek:'', nama_supplier:'',
    tgl_terima: tglHariIni(), catatan:'', fotoDokumen:[], noPO:'',
    items:[{ ...itemKosong }]
  });

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) {
    setForm(prev => ({ ...prev, items: prev.items.map((it,i)=>i===idx?{...it,[field]:value}:it) }));
  }
 function tambahItem() { setForm({...form,items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form,items:form.items.filter((_,i)=>i!==idx)}); }

  async function handleUpload(e) {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    try {
      const result = await uploadAPI.uploadBAPB(files);
      if (result.ok) {
        setForm(prev => ({ ...prev, fotoDokumen: [...prev.fotoDokumen, ...result.data.files] }));
      } else { alert(`❌ ${result.data.message}`); }
    } catch (err) { alert('❌ Gagal upload file'); }
    finally { e.target.value = ''; }
  }
  function hapusFoto(idx) { setForm({...form,fotoDokumen:form.fotoDokumen.filter((_,i)=>i!==idx)}); }

  async function submitGR() {
    if (!form.nama_supplier||!form.tgl_terima){alert('⚠️ Supplier dan tanggal wajib diisi!');return;}
    if (!form.items[0].nama){alert('⚠️ Minimal 1 item wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await pengadaanAPI.createGR({
        po_id:        form.po_id ? Number(form.po_id) : null,
        no_proyek:    form.no_proyek,
        nama_proyek:  form.nama_proyek,
        nama_supplier:form.nama_supplier,
        tgl_terima:   form.tgl_terima,
        catatan:      form.catatan,
        items:        form.items.filter(i=>i.nama),
        lampiran:     form.fotoDokumen,
        no_po_text:   form.noPO,
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ proyek_id:'', po_id:'', no_proyek:'', nama_proyek:'', nama_supplier:'', tgl_terima:tglHariIni(), catatan:'', fotoDokumen:[], noPO:'', items:[{...itemKosong}] });
        refetch();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #ddd', padding:'5px 8px', fontSize:'12px', verticalAlign:'middle' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };

  function renderBAPB(data, isForm=false) {
    const items = isForm ? form.items : (data.items||[]);
    const fotos = isForm ? form.fotoDokumen : (data.lampiran||[]);

    return (
      <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px', WebkitOverflowScrolling:'touch' }}>
        <KopFormulir
          judulFormulir="Berita Acara Penerimaan Barang (BAPB)"
          rows={[
            ['No. Dok', 'MKMJ/FM/LOG/01-01'],
            ['Revisi', '01'],
            ['Tgl. Terbit', '01 Juni 2026'],
          ]}
        />

        <div className="bapb-info-grid" style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'6px', gridColumn:'1 / -1' }}>
            <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Proyek</span>
            <span>:</span>
            {isForm ? (
              <div style={{ flex:1 }}>
                <SelectProyek
                  value={form.proyek_id}
                  onChange={(val)=>{
                    const dipilih = dataProyekList.find(p => String(p.id) === String(val));
                    setForm(prev => ({ ...prev, proyek_id: val, no_proyek: dipilih?.kode || '', nama_proyek: dipilih?.nama || '' }));
                  }}
                  list={dataProyekList}
                />
              </div>
            ) : (
              <span style={{ flex:1 }}>{data.no_proyek ? `${data.no_proyek} · ${data.nama_proyek}` : (data.nama_proyek || '—')}</span>
            )}
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
            <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>No. BAPB</span>
            <span>:</span>
            <span style={{ flex:1, fontWeight:'700', color:'#1a3a5c', background:'#f0f4f8', padding:'5px 8px', borderRadius:'6px' }}>
              {isForm ? generateId('BAPB', listGR) : data.no_bapb}
            </span>
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
            <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>No. PO Terkait</span>
            <span>:</span>
            {isForm
              ? <input name="noPO" value={form.noPO} onChange={handleChange} placeholder="No. PO" style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
              : <span style={{ flex:1 }}>{data.no_po_text || '—'}</span>
            }
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
            <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Nama Supplier</span>
            <span>:</span>
            {isForm ? (
              <div style={{ flex:1 }}>
                <SelectSupplier value={form.nama_supplier} onChange={(val)=>setForm(prev=>({ ...prev, nama_supplier: val }))} list={dataVendorListLive} />
              </div>
            ) : (
              <span style={{ flex:1 }}>{data.nama_supplier || '—'}</span>
            )}
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
            <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Tanggal Penerimaan</span>
            <span>:</span>
            {isForm
              ? <input type="date" name="tgl_terima" value={form.tgl_terima} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
              : <span style={{ flex:1 }}>{data.tgl_terima?.split('T')[0] || '—'}</span>
            }
          </div>
        </div>

        <div className="bapb-table-view" style={{ overflowX:'auto', overflowY: isForm?'auto':'visible', maxHeight: isForm?'260px':'none' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'560px' }}>
            <thead style={{ position: isForm?'sticky':'static', top:0, zIndex:1 }}>
              <tr>
                <th style={thS}>No.</th>
                <th style={thS}>Nama Barang</th>
                <th style={thS}>Spesifikasi</th>
                <th style={thS}>Satuan</th>
                <th style={{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'70px'}}>Jumlah PO</th>
                <th style={{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'80px'}}>Jumlah Diterima</th>
                <th style={{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'90px'}}>Kondisi / Mutu</th>
                <th style={{...thS, whiteSpace:'normal', wordBreak:'break-word', maxWidth:'70px'}}>Sesuai (✓/✗)</th>
                {isForm && <th style={thS}></th>}
              </tr>
            </thead>
            <tbody>
              {items.map((item,idx)=>{
                const selisih = isForm
                  ? Number(item.jumlahPO||0) - Number(item.jumlahTerima||0)
                  : Number(item.jumlah_po||0) - Number(item.jumlah_terima||0);
                return (
                  <tr key={idx} style={{ background: item.sesuai==='✗'?'#fff8f8': item.sesuai==='✓'?'#f8fff8':'white' }}>
                    <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#666', width:'32px' }}>{idx+1}</td>
                    <td style={{ ...tdS, padding: isForm?'3px':'5px 8px' }}>
                      {isForm ? (
                        <SelectMaterial
                          value={item.nama}
                          onChange={(nilai)=>updateItem(idx,'nama',nilai)}
                          onPilihItem={(m)=>updateItem(idx,'satuan', m.satuan || item.satuan)}
                          list={barangList}
                        />
                      ) : item.nama}
                    </td>
                    <td style={{ ...tdS, padding: isForm?'3px':'5px 8px' }}>
                      {isForm ? <input value={item.spesifikasi} onChange={e=>updateItem(idx,'spesifikasi',e.target.value)} placeholder="Spesifikasi" style={inC} /> : item.spesifikasi}
                    </td>
                    <td style={{ ...tdS, width:'70px', padding: isForm?'3px':'5px 8px', textAlign:'center' }}>
                      {isForm ? <input value={item.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="sak" style={{ ...inC, textAlign:'center' }} /> : item.satuan}
                    </td>
                    <td style={{ ...tdS, width:'80px', textAlign:'center' }}>
                      {isForm ? <input type="number" value={item.jumlahPO} onChange={e=>updateItem(idx,'jumlahPO',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }} /> : item.jumlah_po}
                    </td>
                    <td style={{ ...tdS, width:'90px', textAlign:'center', fontWeight:'600', color: selisih>0&&!isForm?'#e74c3c':'#333' }}>
                      {isForm ? <input type="number" value={item.jumlahTerima} onChange={e=>updateItem(idx,'jumlahTerima',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }} /> : <>{item.jumlah_terima}{selisih>0 && <div style={{ fontSize:'10px', color:'#e74c3c' }}>-{selisih}</div>}</>}
                    </td>
                    <td style={{ ...tdS, padding: isForm?'3px':'5px 8px' }}>
                      {isForm ? (
                        <select value={item.kondisi} onChange={e=>updateItem(idx,'kondisi',e.target.value)} style={{ ...inC, cursor:'pointer' }}>
                          <option value="">— Pilih —</option>
                          <option value="Baik">✅ Baik</option>
                          <option value="Rusak sebagian">⚠️ Rusak sebagian</option>
                          <option value="Tidak sesuai spesifikasi">❌ Tidak sesuai spesifikasi</option>
                          <option value="Kurang quantity">📉 Kurang quantity</option>
                        </select>
                      ) : item.kondisi}
                    </td>
                    <td style={{ ...tdS, width:'90px', textAlign:'center' }}>
                      {isForm ? (
                        <select value={item.sesuai} onChange={e=>updateItem(idx,'sesuai',e.target.value)}
                          style={{ ...inC, textAlign:'center', cursor:'pointer', fontWeight:'700', fontSize:'16px', color: item.sesuai==='✓'?'#27ae60': item.sesuai==='✗'?'#e74c3c':'#888' }}>
                          <option value="">—</option>
                          <option value="✓">✓</option>
                          <option value="✗">✗</option>
                        </select>
                      ) : (
                        <span style={{ fontSize:'16px', fontWeight:'700', color: item.sesuai==='✓'?'#27ae60':'#e74c3c' }}>{item.sesuai}</span>
                      )}
                    </td>
                    {isForm && (
                      <td style={{ ...tdS, width:'32px', textAlign:'center' }}>
                        {items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'14px', opacity:0.4 }}>🗑️</button>}
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="bapb-card-view">
          {items.map((item,idx)=>{
            const selisih = isForm
              ? Number(item.jumlahPO||0) - Number(item.jumlahTerima||0)
              : Number(item.jumlah_po||0) - Number(item.jumlah_terima||0);
            return (
              <div key={idx} className="bapb-card">
                <div className="bapb-card-row"><span>No.</span><span>{idx+1}</span></div>
                <div className="bapb-card-row" style={{ flexDirection:'column', alignItems:'flex-start' }}>
                  <span>Nama Barang</span>
                  {isForm ? (
                    <div style={{ width:'100%' }}>
                      <SelectMaterial
                        value={item.nama}
                        onChange={(nilai)=>updateItem(idx,'nama',nilai)}
                        onPilihItem={(m)=>updateItem(idx,'satuan', m.satuan || item.satuan)}
                        list={barangList}
                      />
                    </div>
                  ) : <span>{item.nama}</span>}
                </div>
                <div className="bapb-card-row" style={{ flexDirection:'column', alignItems:'flex-start' }}>
                  <span>Spesifikasi</span>
                  {isForm ? <input value={item.spesifikasi} onChange={e=>updateItem(idx,'spesifikasi',e.target.value)} placeholder="Spesifikasi" style={{...inC, border:'1px solid #ddd', background:'#fafafa'}} /> : <span>{item.spesifikasi}</span>}
                </div>
                <div className="bapb-card-row">
                  <span>Satuan</span>
                  {isForm ? <input value={item.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="sak" style={{...inC, border:'1px solid #ddd', background:'#fafafa', width:'80px'}} /> : <span>{item.satuan}</span>}
                </div>
                <div className="bapb-card-row">
                  <span>Jumlah PO</span>
                  {isForm ? <input type="number" value={item.jumlahPO} onChange={e=>updateItem(idx,'jumlahPO',e.target.value)} placeholder="0" style={{...inC, border:'1px solid #ddd', background:'#fafafa', width:'80px'}} /> : <span>{item.jumlah_po}</span>}
                </div>
                <div className="bapb-card-row">
                  <span>Jumlah Diterima</span>
                  {isForm ? <input type="number" value={item.jumlahTerima} onChange={e=>updateItem(idx,'jumlahTerima',e.target.value)} placeholder="0" style={{...inC, border:'1px solid #ddd', background:'#fafafa', width:'80px'}} /> : <span>{item.jumlah_terima}{selisih>0 && ` (-${selisih})`}</span>}
                </div>
                <div className="bapb-card-row" style={{ flexDirection:'column', alignItems:'flex-start' }}>
                  <span>Kondisi / Mutu</span>
                  {isForm ? (
                    <select value={item.kondisi} onChange={e=>updateItem(idx,'kondisi',e.target.value)} style={{...inC, border:'1px solid #ddd', background:'#fafafa'}}>
                      <option value="">— Pilih —</option>
                      <option value="Baik">✅ Baik</option>
                      <option value="Rusak sebagian">⚠️ Rusak sebagian</option>
                      <option value="Tidak sesuai spesifikasi">❌ Tidak sesuai spesifikasi</option>
                      <option value="Kurang quantity">📉 Kurang quantity</option>
                    </select>
                  ) : <span>{item.kondisi}</span>}
                </div>
                <div className="bapb-card-row">
                  <span>Sesuai</span>
                  {isForm ? (
                    <select value={item.sesuai} onChange={e=>updateItem(idx,'sesuai',e.target.value)} style={{...inC, border:'1px solid #ddd', background:'#fafafa', width:'60px', fontWeight:'700'}}>
                      <option value="">—</option>
                      <option value="✓">✓</option>
                      <option value="✗">✗</option>
                    </select>
                  ) : <span style={{ fontWeight:'700', color: item.sesuai==='✓'?'#27ae60':'#e74c3c' }}>{item.sesuai}</span>}
                </div>
                {isForm && items.length>1 && (
                  <button onClick={()=>hapusItem(idx)} style={{ marginTop:'6px', padding:'6px', background:'#fdedec', color:'#e74c3c', border:'none', borderRadius:'6px', fontSize:'12px', cursor:'pointer' }}>🗑️ Hapus Item</button>
                )}
              </div>
            );
          })}
        </div>

        {isForm && (
          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', background:'#fafcff', borderBottom:'1px solid #ddd' }}>
            <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>+ Tambah Item</button>
          </div>
        )}

        <div style={{ padding:'10px 16px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd' }}>
          <div style={{ fontSize:'12px', fontWeight:'600', color:'#444', marginBottom:'6px' }}>Catatan:</div>
          {isForm ? (
            <textarea name="catatan" value={form.catatan} onChange={handleChange} rows="2" placeholder="Catatan penerimaan, kondisi khusus, tindak lanjut..." style={{ ...inputStyle, resize:'vertical', fontSize:'12px' }} />
          ) : (
            <p style={{ fontSize:'12px', color:'#555', margin:0 }}>{data.keterangan || 'Ditandatangani oleh penerima barang dan diketahui QC untuk material yang memerlukan pemeriksaan mutu.'}</p>
          )}
        </div>

        <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd' }}>
          <div style={{ fontSize:'12px', fontWeight:'700', color:'#444', marginBottom:'10px' }}>📎 Lampiran Foto & Dokumen Surat Jalan</div>
          {isForm && (
            <label style={{ display:'flex', alignItems:'center', gap:'10px', padding:'10px 16px', background:'#f8fbff', border:'2px dashed #2d6a9f', borderRadius:'8px', cursor:'pointer', marginBottom:'12px', fontSize:'12px', color:'#2d6a9f', fontWeight:'600' }}>
              <span style={{ fontSize:'20px' }}>📁</span>
              <div>
                <div>Klik untuk upload foto / surat jalan</div>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>JPG, PNG, PDF — Maks. 5MB per file</div>
              </div>
              <input type="file" multiple accept="image/*,.pdf" onChange={handleUpload} style={{ display:'none' }} />
            </label>
          )}
          {fotos.length > 0 ? (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(120px, 1fr))', gap:'10px' }}>
              {fotos.map((f,i)=>(
                <div key={i} style={{ border:'1px solid #e0e8f4', borderRadius:'8px', overflow:'hidden', position:'relative' }}>
                  {f.isImg ? (
                    <img src={f.url.startsWith('http')?f.url:`${f.url}`} alt={f.name} style={{ width:'100%', height:'90px', objectFit:'cover', display:'block' }} />
                  ) : (
                    <div style={{ width:'100%', height:'90px', background:'#f0f4f8', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'4px' }}>
                      <span style={{ fontSize:'28px' }}>📄</span>
                      <span style={{ fontSize:'10px', color:'#666', textAlign:'center', padding:'0 4px' }}>PDF</span>
                    </div>
                  )}
                  <div style={{ padding:'6px 8px', background:'white' }}>
                    <div style={{ fontSize:'10px', fontWeight:'600', color:'#333', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={f.name}>{f.name}</div>
                    <div style={{ fontSize:'10px', color:'#aaa' }}>{f.size}</div>
                  </div>
                  {isForm && (
                    <button onClick={()=>hapusFoto(i)} style={{ position:'absolute', top:'4px', right:'4px', background:'rgba(0,0,0,0.5)', color:'white', border:'none', borderRadius:'50%', width:'20px', height:'20px', cursor:'pointer', fontSize:'11px', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
                  )}
                  {!isForm && f.isImg && (
                    <a href={f.url.startsWith('http')?f.url:`${f.url}`} target="_blank" rel="noreferrer" style={{ position:'absolute', inset:0, display:'block' }} />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div style={{ fontSize:'12px', color:'#aaa', fontStyle:'italic' }}>{isForm ? 'Belum ada lampiran ditambahkan' : 'Tidak ada lampiran'}</div>
          )}
        </div>

        {/* TANDA TANGAN */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr' }}>
          <div style={{ padding:'14px 20px', borderRight:'1px solid #ddd' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'52px' }}>Dibuat oleh,</div>
            <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
              <div style={{ fontSize:'11px', color:'#555' }}>( {user?.nama||'................................'} )</div>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{user?.role||'Logistic Staff'}</div>
            </div>
          </div>
          <div style={{ padding:'14px 20px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'52px' }}>Diketahui oleh,</div>
            <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
              <div style={{ fontSize:'11px', color:'#555' }}>( ................................ )</div>
              <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>Logistic Manager</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'16px' }}>
        <Btn onClick={()=>setShowForm(true)}>+ Catat Penerimaan (BAPB)</Btn>
      </div>

      {loading && <LoadingSpinner pesan="Memuat data penerimaan..." />}
      {error   && <ErrorBox pesan={error} onRetry={refetch} />}

      {!loading && !error && (
        listGR.length === 0
          ? <EmptyState icon="📦" judul="Belum ada penerimaan" sub="Klik '+ Catat Penerimaan' untuk mencatat BAPB" />
          : (
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                    {['No. BAPB','Tgl','No. PO','Supplier','Material','Qty PO','Qty Terima','Selisih','Kondisi','Diterima','Aksi'].map(h=>(
                      <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {listGR.map(gr=>{
                    const selisih = Number(gr.qty_po||0) - Number(gr.qty_terima||0);
                    return (
                      <tr key={gr.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                        <td style={{ padding:'12px', fontSize:'13px' }}><strong>{gr.no_bapb}</strong></td>
                        <td style={{ padding:'12px', fontSize:'12px' }}>{gr.tgl_terima?.split('T')[0]}</td>
                        <td style={{ padding:'12px', fontSize:'12px' }}>{gr.po_id||'—'}</td>
                        <td style={{ padding:'12px', fontSize:'12px' }}>{gr.nama_supplier}</td>
                        <td style={{ padding:'12px', fontSize:'12px' }}>{gr.material||'—'}</td>
                        <td style={{ padding:'12px', fontSize:'13px', textAlign:'center' }}>{gr.qty_po||'—'}</td>
                        <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600', textAlign:'center' }}>{gr.qty_terima||'—'}</td>
                        <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600', textAlign:'center', color:selisih>0?'#e74c3c':'#27ae60' }}>{gr.qty_po ? (selisih>0?`-${selisih}`:'✅') : '—'}</td>
                        <td style={{ padding:'12px' }}><Badge status={gr.kondisi||'Baik'} /></td>
                        <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{gr.nama_penerima||'—'}</td>
                        <td style={{ padding:'12px' }}>
                          <button onClick={()=>setShowDetail(gr)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>Detail</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
      )}

      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📦 Berita Acara Penerimaan Barang (BAPB)" size="min(820px, 96vw)"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn color="hijau" onClick={submitGR} disabled={submitting}>{submitting?'⏳ Menyimpan...':'✅ Simpan BAPB'}</Btn>
        </>}
      >
        {renderBAPB(null, true)}
      </Modal>

      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail BAPB — ${showDetail?.no_bapb}`} size="min(820px, 96vw)"
        footer={<Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>}
      >
        {showDetail && renderBAPB(showDetail, false)}
      </Modal>
    </div>
  );
}


// ============================================
// TAB: BARANG KELUAR
// ============================================
function TabBarangKeluar({ user, gudangList, barangList }) {
  const proyekList = useProyekListG();
  const [list, setList]         = useState([]);
  const [rabList, setRabList]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [tujuanForm, setTujuanForm] = useState('manual');

  const itemKosong = { barang_id:'', qty:'', keterangan:'' };
  const [form, setForm] = useState({ gudang_id:'', tanggal:tglHariIni(), proyek_id:'', rab_id:'', penerima:'', keperluan:'', catatan:'', items:[{...itemKosong}] });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const result = await gudangAPI.getAllBarangKeluar();
      if (result.ok) setList(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) {
    setForm(prev => ({ ...prev, items: prev.items.map((it,i)=>i===idx?{...it,[field]:value}:it) }));
    }
  function tambahItem() { setForm({...form, items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form, items: form.items.filter((_,i)=>i!==idx)}); }

  async function pilihProyek(id) {
    setForm({...form, proyek_id:id, rab_id:'', items:[{...itemKosong}]});
    if (id) {
      const r = await gudangAPI.getRABUntukKeluar(id);
      if (r.ok) setRabList(r.data.data);
    } else setRabList([]);
  }

  function pilihRAB(id) {
    const rab = rabList.find(r=>String(r.id)===id);
    if (!rab) { setForm({...form, rab_id:''}); return; }
    // Coba cocokkan nama RAB dengan barang master (opsional, kalau tidak ketemu tetap manual)
    setForm({ ...form, rab_id:id, keperluan: rab.uraian, items:[{ barang_id:'', qty:'', keterangan: `Ref. RAB: ${rab.kode} - ${rab.uraian}` }] });
  }

  async function submitForm() {
    if (!form.gudang_id || !form.tanggal || !form.items[0].barang_id || !form.items[0].qty) { alert('⚠️ Gudang, tanggal, dan item wajib diisi lengkap!'); return; }
    setSubmitting(true);
    try {
      const result = await gudangAPI.createBarangKeluar({
        ...form,
        tujuan: tujuanForm,
        proyek_id: form.proyek_id?Number(form.proyek_id):null,
        rab_id: form.rab_id?Number(form.rab_id):null,
        items: form.items.filter(i=>i.barang_id&&i.qty).map(i=>({ ...i, barang_id:Number(i.barang_id) })),
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ gudang_id:'', tanggal:tglHariIni(), proyek_id:'', rab_id:'', penerima:'', keperluan:'', catatan:'', items:[{...itemKosong}] });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8' };
  const tdS = { border:'1px solid #ddd', padding:'6px 8px', fontSize:'12px' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        <Btn onClick={()=>{ setTujuanForm('manual'); setShowForm(true); }}>+ Catat Barang Keluar</Btn>
      </div>

      {loading ? <LoadingSpinner pesan="Memuat data..." /> : (
        list.length===0 ? <EmptyState icon="📤" judul="Belum ada barang keluar" sub="Klik '+ Catat Barang Keluar' untuk mencatat" /> : (
          <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                {['No. BK','Tgl','Gudang','Tujuan','Proyek','Penerima','Jenis Item','Aksi'].map(h=>(
                  <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {list.map(bk=>(
                  <tr key={bk.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'700' }}>{bk.no_bk}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{bk.tanggal?.split('T')[0]}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{bk.nama_gudang}</td>
                    <td style={{ padding:'12px' }}>
                      <span style={{ padding:'2px 8px', borderRadius:'6px', fontSize:'11px', fontWeight:'600', background: bk.tujuan==='rab'?'#eaf0fb':'#f0f4f8', color: bk.tujuan==='rab'?'#2980b9':'#666' }}>
                        {bk.tujuan==='rab'?'📋 Kebutuhan RAB':'✍️ Manual'}
                      </span>
                    </td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{bk.nama_proyek||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{bk.penerima||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{bk.items?.length||0} item</td>
                    <td style={{ padding:'12px' }}>
                      <button onClick={()=>setShowDetail(bk)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>Detail</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

        {/* MODAL FORM */}
        <Modal show={showForm} onClose={()=>setShowForm(false)} title="📤 Catat Barang Keluar" size="min(820px, 96vw)"
          footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn color="merah" onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>

          <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>

            <KopFormulir
              judulFormulir="Bukti Barang Keluar Gudang"
              rows={[
                ['No. Dok', 'MKMJ/FM/LOG/01-02'],
                ['Revisi', '01'],
                ['Tgl. Terbit', '01 Juni 2026'],
              ]}
            />

            <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd' }}>
              <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
                <button onClick={()=>{ setTujuanForm('manual'); setForm({...form, proyek_id:'', rab_id:''}); }} style={{ padding:'8px 16px', border:'none', borderRadius:'8px', fontSize:'12px', fontWeight:'600', cursor:'pointer', background: tujuanForm==='manual'?'#1a3a5c':'#f0f4f8', color: tujuanForm==='manual'?'white':'#666' }}>✍️ Permintaan Manual</button>
                <button onClick={()=>setTujuanForm('rab')} style={{ padding:'8px 16px', border:'none', borderRadius:'8px', fontSize:'12px', fontWeight:'600', cursor:'pointer', background: tujuanForm==='rab'?'#1a3a5c':'#f0f4f8', color: tujuanForm==='rab'?'white':'#666' }}>📋 Kebutuhan RAB Proyek</button>
              </div>

              {tujuanForm==='rab' && (
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px', marginBottom:'8px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                    <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Proyek</span>
                    <span>:</span>
                    <select value={form.proyek_id} onChange={e=>pilihProyek(e.target.value)} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }}>
                      <option value="">-- Pilih --</option>
                      {proyekList.map(p=><option key={p.id} value={p.id}>{p.nama}</option>)}
                    </select>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                    <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Item RAB</span>
                    <span>:</span>
                    <select value={form.rab_id} onChange={e=>pilihRAB(e.target.value)} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} disabled={!form.proyek_id}>
                      <option value="">-- Pilih Item RAB --</option>
                      {rabList.map(r=><option key={r.id} value={r.id}>{r.kode} · {r.uraian}</option>)}
                    </select>
                  </div>
                </div>
              )}

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Gudang Sumber</span>
                  <span>:</span>
                  <select name="gudang_id" value={form.gudang_id} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }}>
                    <option value="">-- Pilih --</option>
                    {gudangList.map(g=><option key={g.id} value={g.id}>{g.nama}</option>)}
                  </select>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Tanggal</span>
                  <span>:</span>
                  <input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Penerima</span>
                  <span>:</span>
                  <input name="penerima" value={form.penerima} onChange={handleChange} placeholder="Nama penerima" style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>Keperluan</span>
                  <span>:</span>
                  <input name="keperluan" value={form.keperluan} onChange={handleChange} placeholder="Keperluan pengambilan" style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
                </div>
              </div>
            </div>

            <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd', fontSize:'12px', color:'#333', fontStyle:'italic' }}>
              Bahwa telah dilakukan pengeluaran barang dari gudang sesuai rincian berikut :
            </div>

            <div style={{ overflowX:'auto', overflowY:'auto', maxHeight:'240px' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'500px' }}>
                <thead style={{ position:'sticky', top:0, zIndex:1 }}>
                  <tr>{['No.','Barang','Qty Keluar','Keterangan',''].map(h=><th key={h} style={thS}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {form.items.map((it,idx)=>(
                    <tr key={idx}>
                      <td style={{ ...tdS, textAlign:'center', fontWeight:'700', width:'28px' }}>{idx+1}</td>
                      <td style={{ ...tdS, padding:'3px', width:'180px' }}>
                        <SelectMaterialG
                          value={it.barang_id}
                          onChange={(val)=>updateItem(idx,'barang_id',val)}
                          onPilihItem={(m)=>updateItem(idx,'satuan_manual', m.satuan || it.satuan_manual)}
                          list={barangList}
                        />
                      </td>
                      <td style={{ ...tdS, padding:'3px', width:'100px' }}><input type="number" value={it.qty} onChange={e=>updateItem(idx,'qty',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }} /></td>
                      <td style={{ ...tdS, padding:'3px' }}><input value={it.keterangan} onChange={e=>updateItem(idx,'keterangan',e.target.value)} style={inC} /></td>
                      <td style={{ ...tdS, width:'28px', textAlign:'center' }}>{form.items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', opacity:0.4 }}>🗑️</button>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', background:'#fafcff', borderBottom:'1px solid #ddd' }}>
              <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>+ Tambah Baris</button>
            </div>

            <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd' }}>
              <div style={{ fontSize:'12px', fontWeight:'600', color:'#444', marginBottom:'6px' }}>Catatan:</div>
              <textarea name="catatan" value={form.catatan} onChange={handleChange} rows="2" placeholder="Catatan tambahan..." style={{ ...inputStyle, resize:'vertical', fontSize:'12px' }} />
            </div>

            <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd', fontSize:'11px', color:'#c0392b' }}>
              ⚠️ Sistem otomatis mengecek stok — pengambilan akan ditolak jika stok tidak mencukupi.
            </div>

            {/* TANDA TANGAN */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr' }}>
              <div style={{ padding:'14px 20px', borderRight:'1px solid #ddd' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'52px' }}>Dibuat oleh,</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {user?.nama||'................................'} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{user?.role||'Logistic Staff'}</div>
                </div>
              </div>
              <div style={{ padding:'14px 20px' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'52px' }}>Diketahui oleh,</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( ................................ )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>Logistic Manager</div>
                </div>
              </div>
            </div>

          </div>

        </Modal>

      {/* MODAL DETAIL */}
      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail — ${showDetail?.no_bk}`}
        footer={<Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>}>
        {showDetail && (
          <div style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
              {[['Gudang',showDetail.nama_gudang],['Tanggal',showDetail.tanggal?.split('T')[0]],['Proyek',showDetail.nama_proyek||'-'],['Penerima',showDetail.penerima||'-'],['Keperluan',showDetail.keperluan||'-']].map(([l,v])=>(
                <div key={l}><p style={{ fontSize:'11px', color:'#888', fontWeight:'700', margin:'0 0 2px' }}>{l}</p><p style={{ fontSize:'13px', margin:0 }}>{v}</p></div>
              ))}
            </div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr>{['No.','Nama Barang','Qty','Satuan'].map(h=><th key={h} style={thS}>{h}</th>)}</tr></thead>
              <tbody>{(showDetail.items||[]).map((it,i)=>(
                <tr key={i}>
                  <td style={{ ...tdS, textAlign:'center' }}>{i+1}</td>
                  <td style={tdS}>{it.nama_barang}</td>
                  <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#e74c3c' }}>{it.qty}</td>
                  <td style={{ ...tdS, textAlign:'center' }}>{it.satuan}</td>
                </tr>
              ))}</tbody>
            </table>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', borderTop:'1px solid #ddd', paddingTop:'14px', marginTop:'4px' }}>
              <div>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>Penerima Barang,</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {showDetail.penerima||'-'} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>&nbsp;</div>
                </div>
              </div>
              <div>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>Dibuat oleh,</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {showDetail.nama_pembuat||'-'} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

// ============================================
// TAB: LOKASI (Gudang)
// ============================================
function TabLokasi({ gudangList, refreshGudang }) {
  const [showFormGudang, setShowFormGudang] = useState(false);
  const [editGudang, setEditGudang]         = useState(null);
  const [detailGudang, setDetailGudang]     = useState(null);
  const [submitting, setSubmitting]         = useState(false);
  const [formGudang, setFormGudang]         = useState({ kode:'', nama:'', lokasi:'', pic:'' });

  function bukaTambahGudang() {
    setEditGudang(null);
    setFormGudang({ kode:'', nama:'', lokasi:'', pic:'' });
    setShowFormGudang(true);
  }

  function bukaEditGudang(g) {
    setEditGudang(g);
    setFormGudang({ kode:g.kode||'', nama:g.nama||'', lokasi:g.lokasi||'', pic:g.pic||'' });
    setShowFormGudang(true);
  }

  async function submitGudang() {
    if (!formGudang.kode || !formGudang.nama) { alert('⚠️ Kode dan nama wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = editGudang
        ? await gudangAPI.updateGudang(editGudang.id, formGudang)
        : await gudangAPI.createGudang(formGudang);
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowFormGudang(false);
        setEditGudang(null);
        setFormGudang({ kode:'', nama:'', lokasi:'', pic:'' });
        refreshGudang();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'20px' }}>

      {/* LOKASI GUDANG */}
      <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'14px' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>🏬 Lokasi Gudang</h3>
          <Btn size="small" onClick={bukaTambahGudang}>+ Tambah Gudang</Btn>
        </div>
        {gudangList.length === 0 ? (
          <EmptyState icon="🏬" judul="Belum ada gudang" sub="Klik '+ Tambah Gudang' untuk menambahkan" />
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:'12px' }}>
            {gudangList.map(g=>(
              <div key={g.id} style={{ border:'1px solid #e0e8f4', borderRadius:'10px', padding:'14px', display:'flex', flexDirection:'column', gap:'6px' }}>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'700' }}>{g.kode}</div>
                <div style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c' }}>{g.nama}</div>
                <div style={{ fontSize:'12px', color:'#666' }}>📍 {g.lokasi||'-'}</div>
                <div style={{ fontSize:'12px', color:'#666' }}>👤 {g.pic||'-'}</div>
                <div style={{ display:'flex', gap:'6px', marginTop:'6px' }}>
                  <button onClick={()=>setDetailGudang(g)} style={{ flex:1, padding:'5px 10px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'11px', fontWeight:'600', cursor:'pointer' }}>Lihat Detail</button>
                  <button onClick={()=>bukaEditGudang(g)} style={{ flex:1, padding:'5px 10px', background:'#fff6e0', color:'#b7791f', border:'none', borderRadius:'6px', fontSize:'11px', fontWeight:'600', cursor:'pointer' }}>Edit</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL TAMBAH/EDIT GUDANG */}
      <Modal show={showFormGudang} onClose={()=>{ setShowFormGudang(false); setEditGudang(null); }} title={editGudang ? `✏️ Edit Gudang — ${editGudang.nama}` : '🏬 Tambah Lokasi Gudang'} size="420px"
        footer={<><Btn color="abu" onClick={()=>{ setShowFormGudang(false); setEditGudang(null); }} disabled={submitting}>Batal</Btn><Btn onClick={submitGudang} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <FG label="Kode Gudang" required><input value={formGudang.kode} onChange={e=>setFormGudang({...formGudang,kode:e.target.value})} placeholder="GDG-003" style={inputStyle} /></FG>
        <FG label="Nama Gudang" required><input value={formGudang.nama} onChange={e=>setFormGudang({...formGudang,nama:e.target.value})} placeholder="Gudang Proyek..." style={inputStyle} /></FG>
        <FG label="Lokasi"><input value={formGudang.lokasi} onChange={e=>setFormGudang({...formGudang,lokasi:e.target.value})} placeholder="Kota/alamat" style={inputStyle} /></FG>
        <FG label="PIC"><input value={formGudang.pic} onChange={e=>setFormGudang({...formGudang,pic:e.target.value})} placeholder="Penanggung jawab" style={inputStyle} /></FG>
      </Modal>

      {/* MODAL DETAIL GUDANG */}
      <Modal show={!!detailGudang} onClose={()=>setDetailGudang(null)} title={`Detail Gudang — ${detailGudang?.nama}`} size="420px"
        footer={<Btn color="abu" onClick={()=>setDetailGudang(null)}>Tutup</Btn>}>
        {detailGudang && (
          <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
            {[['Kode',detailGudang.kode],['Nama',detailGudang.nama],['Lokasi',detailGudang.lokasi||'-'],['PIC',detailGudang.pic||'-']].map(([l,v])=>(
              <div key={l}><p style={{ fontSize:'11px', color:'#888', fontWeight:'700', margin:'0 0 2px' }}>{l}</p><p style={{ fontSize:'13px', margin:0 }}>{v}</p></div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
}

// ============================================
// KOMPONEN UTAMA: GUDANG
// ============================================
function Gudang({ user }) {
  const [tabAktif, setTabAktif] = useState('stok');
  const [gudangList, setGudangList] = useState([]);
  const [barangList, setBarangList] = useState([]);

  useEffect(() => { refreshGudang(); refreshBarang(); }, []);

  async function refreshGudang() { const r = await gudangAPI.getAllGudang(); if(r.ok) setGudangList(r.data.data); }
  async function refreshBarang() { const r = await gudangAPI.getAllBarang(); if(r.ok) setBarangList(r.data.data); }

  const tabs = [
    { id:'stok',   label:'📦 Stok Material' },
    { id:'gr',     label:'📥 Penerimaan Barang' },
    { id:'keluar', label:'📤 Barang Keluar' },
    { id:'lokasi', label:'📍 Lokasi'        },
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Gudang</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Stok Material · Barang Masuk · Barang Keluar</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>
        <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', flexWrap:'wrap' }}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setTabAktif(t.id)} style={{
              padding:'10px 20px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer',
              background: tabAktif===t.id?'#1a3a5c':'transparent', color: tabAktif===t.id?'white':'#888',
            }}>{t.label}</button>
          ))}
        </div>

        {tabAktif==='stok'   && <TabStok gudangList={gudangList} />}
        {tabAktif==='gr'     && <TabGR user={user} barangList={barangList} />}
        {tabAktif==='keluar' && <TabBarangKeluar user={user} gudangList={gudangList} barangList={barangList} />}
        {tabAktif==='lokasi' && <TabLokasi gudangList={gudangList} refreshGudang={refreshGudang} />}
      </div>
    </div>
  );
}

export default Gudang;